import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function SpringBootIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_10640_68247)">
        <path
          d="M23.694 10.6785L18.9646 2.32154C18.5552 1.59589 17.5481 1 16.7246 1H7.27518C6.45636 1 5.44459 1.59589 5.03518 2.32154L0.310477 10.6785C-0.098935 11.4041 -0.098935 12.5911 0.310477 13.3167L5.03518 21.6785C5.44459 22.4041 6.45165 23 7.27518 23H16.7293C17.5481 23 18.5552 22.4041 18.9693 21.6785L23.694 13.3167C24.1034 12.5911 24.1034 11.4041 23.694 10.6785ZM10.9787 5.62298C10.9787 5.07514 11.4164 4.62822 11.9528 4.62822C12.4893 4.62822 12.9269 5.07514 12.9269 5.62298V11.5675C12.9269 12.1153 12.4893 12.5623 11.9528 12.5623C11.4164 12.5623 10.9787 12.1153 10.9787 11.5675V5.62298ZM11.9528 18.3145C8.31048 18.3145 5.34577 15.287 5.34577 11.5675C5.35048 9.43381 6.33871 7.42988 8.01401 6.15159C8.39989 5.85845 8.94107 5.94015 9.22812 6.33421C9.51518 6.72827 9.43518 7.28091 9.0493 7.57405C6.8893 9.21276 6.43754 12.3316 8.04224 14.5374C9.64695 16.7431 12.7011 17.2045 14.8611 15.5657C16.0987 14.6287 16.8281 13.1437 16.8281 11.5675C16.8234 9.98646 16.0893 8.50153 14.8422 7.55963C14.4564 7.2713 14.3764 6.71385 14.6587 6.31979C14.9411 5.92573 15.4869 5.84404 15.8728 6.13237C17.5622 7.40585 18.5552 9.4242 18.5599 11.5675C18.5599 15.2918 15.5952 18.3145 11.9528 18.3145Z"
          fill="#6DB33F"
        />
      </g>
      <defs>
        <clipPath id="clip0_10640_68247">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
